/**
 * 发送按钮
 */

import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import { useBoolean, useInput, useNumber, useStateful } from 'react-hanger';

import { UiToast } from 'components';
import { request } from 'lib';
import { getLibUrl } from 'lib/base';

import room from '../../lib/room';
import { StyledSendAction, StyledSendPopup, StyledEmojiPanel } from './styled';
import { useStore } from 'modules/widgets/functions/broadcast/store';

let { getRoomId } = room;

// TODO: 将表情模块抽出为独立组件
export const commonEmojiData = {
  ary: [
    '微笑',
    '撇嘴',
    '色',
    '得意',
    '流泪',
    '害羞',
    '睡',
    '大哭',
    '尴尬',
    '生气',
    '调皮',
    '呲牙',
    '惊讶',
    '难过',
    '酷',
    '冷汗',
    '淘气',
    '吐',
    '偷笑',
    '可爱',
    '白眼',
    '傲慢',
    '舔',
    '困',
    '惊恐',
    '汗',
    '大笑',
    '奋斗',
    '咒骂',
    '疑问',
    '嘘',
    '晕',
    '敲打',
    '拜拜',
    '擦汗',
    '抠鼻',
    '高兴',
    '糗大了',
    '窃笑',
    '左哼哼',
    '右哼哼',
    '哈欠',
    '鄙视',
    '委屈',
    '快哭了',
    '阴险',
    '亲亲',
    '可怜',
    '菜刀',
    '吃饭',
    '猪头',
    '吻',
    '爱心',
    '心碎',
    '便便',
    '月亮',
    '拥抱',
    '给力',
    '不给力',
    '握手',
    '胜利',
    '抱拳',
    '勾引',
    '拳头',
    '差劲',
    '爱你',
    'NO',
    'OK',
    '凋谢',
    '发呆',
    '大兵',
    '太阳',
    '炸弹',
    '玫瑰',
    '礼物',
    '蛋糕',
    '衰',
    '闭嘴',
    '骷髅',
    '干杯',
  ],
  prefix: '/',
  postfix: 'gif',
  root: getLibUrl('base/styles/expression/common'),
};

export const replaceExpression = (text) => {
  const { prefix, postfix, root, ary } = commonEmojiData;
  let msg = text;
  if (text.indexOf('/') === -1) {
    return text;
  }
  ary.forEach((item) => {
    const tempReg = new RegExp(`${prefix}${item}`, 'g');
    msg = msg.replace(
      tempReg,
      `<img class="exp-img" title="${item}" alt="${item}" src="${root}${prefix}${item}.${postfix}" />`,
    );
  });
  return msg;
};

export const EmojiPanel = (props) => {
  const { close, onSelectEmoji, className = '' } = props;

  const onSelect = (emoji) => {
    onSelectEmoji(emoji);
    close();
  };

  return (
    <StyledEmojiPanel className={className} onMouseLeave={close}>
      <ul className="fix">
        {commonEmojiData.ary.map((item, index) => {
          const { prefix, postfix, root } = commonEmojiData;
          return (
            <li key={index} onClick={() => onSelect(`${prefix}${item}`)}>
              <img src={`${root}${prefix}${item}.${postfix}`} />
            </li>
          );
        })}
      </ul>
    </StyledEmojiPanel>
  );
};

const SendPopup = (props) => {
  const { toggle } = props;
  const showEmoji = useBoolean(false);
  const count = useNumber(0);
  const inputText = useInput('');
  const info = useStateful({
    horn: 0,
  });
  const maxCount = 30;

  const onSelectEmoji = (emoji) => {
    inputText.setValue(`${inputText.value}${emoji}`.substring(0, maxCount));
  };

  const onSend = () => {
    const roomId = getRoomId();
    request.api
      .get(`room/broadcast/{access_token}/${roomId}`, {
        room_id: roomId,
        content: inputText.value,
        type: 0, // TODO: 需要同步不同 type 区别
        horn: 1,
      })
      .then(() => {
        toggle();
      })
      .catch((error) => {
        console.log('broadcast', error);
        switch (error.code) {
          case 30413:
            UiToast.fail('您已被禁止发广播。请联系客服');
            break;
          case 30412:
            UiToast.fail('余额不足，请充值');
            break;
          case 50025:
            UiToast.info('发送频率过高，请稍后再试');
            break;
          default:
            UiToast.info(error.message);
            break;
        }
      });
  };

  useEffect(() => {
    request.api.get('/user/horn_info/{access_token}').then((res) => {
      info.setValue(res.data);
    });
  }, []);

  useEffect(() => {
    count.setValue(inputText.value.length);
  }, [inputText.value]);

  return (
    <StyledSendPopup>
      <div className="box-hd">
        <p>
          <span>发广播</span>
          <i className="iconfont icon-close" onClick={toggle} />
        </p>
        {!!info.value.horn && (
          <span className="tip-count">
            {' '}
            喇叭剩余：<i>{info.value.horn}</i> (优先使用)
          </span>
        )}
      </div>
      <textarea
        value={inputText.value}
        onChange={inputText.onChange}
        maxLength={maxCount}
        className="input-text"
        placeholder="每条广播10000柠檬，每个房间都可以收到哦。使用广播卡时10分钟内最多可发送1条广播！"
      />
      <div className="box-ft">
        <EmojiPanel
          className={`${showEmoji.value ? '' : 'hide'}`}
          close={showEmoji.setFalse}
          onSelectEmoji={onSelectEmoji}
        />
        <div className="tip-action inline">
          <i className="inline iconfont icon-biaoqing" onClick={showEmoji.toggle} />
          <span className="inline">还能输入 {maxCount - count.value} 个字</span>
        </div>
        <p className="inline btn-send btn btn-primary" onClick={onSend}>
          发布
        </p>
      </div>
    </StyledSendPopup>
  );
};

const SendAction = observer(() => {
  const { togglePopup, showPopup } = useStore();

  return (
    <StyledSendAction>
      {showPopup && <SendPopup toggle={togglePopup} />}
      <div className="btn-action" onClick={togglePopup}>
        <i className="iconfont icon-shengyinxianxing" />
        <span>发广播</span>
      </div>
    </StyledSendAction>
  );
});

export default SendAction;
